import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import ViewOpportunityHistoryDetailsModal from 'components/underwrite/acquisition/propertyUnderwrite/header/ViewOpportunityHistoryDetailsModal';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    CircularProgress,
    IconButton,
    Link
} from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import { TreeList, SearchPanel, Column as TreeListColumn, Sorting } from 'devextreme-react/tree-list';
import { DataGrid, Column } from 'devextreme-react/data-grid';
import {
    fetchOpportunityHistory,
    setEventSummaryRowData,
    fetchOpportunityHistoryTableDetails,
    fetchOpportunityHistoryLogDetails,
    setIsOpportunityHistoryDetailsModalOpen,
    setIsOpportunityHistoryDetailsModalLoading,
    closeViewOpportunityHistoryDetails,
    closeViewOpportunityDetails,
    appNotify
} from 'store/actions';

const ViewOpportunityHistoryModal = ({ appNotify, classes, txnOppId, setEventSummaryRowData, fetchOpportunityHistoryTableDetails, fetchOpportunityHistoryLogDetails, isLoading, opportunityHistory, isViewOpportunityHistoryModalOpen, closeViewOpportunityDetails }) => {

    const eventTypeColumnRender = (e) => {

        if (e.data.summaryDetailsWithHistoryDto) {
            return (
                <DataGrid dataSource={e.data.summaryDetailsWithHistoryDto} showRowLines={true} showColumnLines={true} showBorders={true} columnAutoWidth={true}>
                    <Column dataField='key' caption='Field' />
                    <Column dataField='previousValue' caption='Previous Value' />
                    <Column dataField='updatedValue' caption='Updated Value' />
                </DataGrid>
            )
        } else if (e.data.summaryDetailsWithoutHistoryDto) {
            return (
                <DataGrid wordWrapEnabled={true} dataSource={e.data.summaryDetailsWithoutHistoryDto} showColumnHeaders={false} showRowLines={true} showColumnLines={true} showBorders={true} columnAutoWidth={true}>
                    <Column dataField='key' caption='Field' />
                    <Column dataField='value' caption='Value' />
                </DataGrid>
            )
        }

        return (
            e.data.eventType
        )
    }

    const detailsColumnRender = (e) => {
        if (e.data.detailsTypeDisplay && e.data.detailsTypeDisplay !== 'Import') {
            return (
                <>
                    <Link onClick={() => handleViewDetailsButtonClick(e.data)} underline='hover'>
                        Details
                    </Link>
                </>
            );
        }
    };

    const logsColumnnRender = (e) => {
        const detailsType = e.data.detailsTypeDisplay;
        const shouldRender = (detailsType === 'Allocations' || detailsType === 'Import') && e.data.importOrReloadId

        if (shouldRender) {
            return (
                <>
                    <Link onClick={() => handleViewLogsButtonClick(e.data)} underline='hover'>
                        Logs
                    </Link>
                </>
            )
        }
    }

    const handleViewDetailsButtonClick = (rowData) => {
        setEventSummaryRowData(rowData);
        fetchOpportunityHistoryTableDetails({ txnOppId: txnOppId, eventSummary: rowData });
    }

    const handleViewLogsButtonClick = (rowData) => {
      setEventSummaryRowData(rowData);

      const getPayload = () => {
        if (rowData.detailsTypeDisplay === 'Allocations') {
          return { txnOppId: txnOppId, type: 'Allocations' }
        }

        if (rowData.eventType === 'Reload' || rowData.eventType === 'Edit') {
          return { reloadId: rowData.importOrReloadId, type: 'Reload Import' }
        }

        return { importId: rowData.importOrReloadId, type: 'Opportunity Import' }
      }

      const payload = getPayload()
      fetchOpportunityHistoryLogDetails(payload);
    }

    const handleClose = () => {
        closeViewOpportunityDetails();
    }

    return (
        <>
            <Dialog onClose={handleClose} open={isViewOpportunityHistoryModalOpen} className={classes.dialog} maxWidth={'xl'} fullWidth={true}>
                <DialogTitle>
                    Opportunity Event History - {txnOppId}
                </DialogTitle>
                <IconButton className={classes.closeButton} onClick={handleClose}>
                    <ClearIcon fontSize='inherit' />
                </IconButton>
                <DialogContent>
                    {isLoading &&
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <CircularProgress />
                        </div>
                    }
                    {!isLoading &&
                        <>
                            <TreeList
                                id='opportunityHistory'
                                dataSource={opportunityHistory}
                                showRowLines={true}
                                showColumnLines={true}
                                showBorders={true}
                                columnAutoWidth={true}
                                itemsExpr='subEvents'
                                dataStructure='tree'
                                height={'calc(70vh)'}
                            >
                                <SearchPanel visible={true} />
                                <Sorting mode='none' />
                                <TreeListColumn cellRender={eventTypeColumnRender} caption='Event Type' />
                                <TreeListColumn dataField='eventType' visible={false} caption='Event Type'  />
                                <TreeListColumn dataField='eventDateString' dataType='text' caption='Event Date'/>
                                <TreeListColumn dataField='eventDate' visible={false} dataType='text' caption='Event Date'  />
                                <TreeListColumn dataField='status' caption='Opportunity Status' />
                                <TreeListColumn dataField='underwriteStatus' caption='Underwrite Status'  />
                                <TreeListColumn dataField='user' caption='User' />
                                <TreeListColumn alignment='center' cellRender={detailsColumnRender} caption='Table Details' />
                                <TreeListColumn alignment='center' cellRender={logsColumnnRender} caption='Log Details'  />
                            </TreeList>
                        </>
                    }

                    <ViewOpportunityHistoryDetailsModal
                        txnOppId={txnOppId}
                    />
                </DialogContent>
                <DialogActions>
                    <></>
                </DialogActions>
            </Dialog>
        </>
    )
}

const styles = theme => ({
    dialog: {
        minWidth: '700px',
        minHeight: '150px'
    },
    textFieldRoot: {
        height: 70,
        marginBottom: 16,
        paddingRight: 8,
        flexBasis: '25%'
    },
    errorText: {
        lineHeight: 1
    },
    textWrapper: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    textLabel: {
        minWidth: '200px'
    },
    divider: {
        marginTop: '4px',
        marginBottom: '4px'
    },
    closeButton: {
        position: 'absolute',
        right: 0,
        top: 0,
        backgroundColor: '#ffffff'
    },
});

const mapStateToProps = ({ opportunityHistoryState }) => ({
    opportunityHistory: opportunityHistoryState.opportunityHistory,
    isLoading: opportunityHistoryState.isViewOpportunityHistoryModalLoading,
    eventSummaryRowData: opportunityHistoryState.eventSummaryRowData,
    isViewOpportunityHistoryModalOpen: opportunityHistoryState.isViewOpportunityHistoryModalOpen,
    txnOppId: opportunityHistoryState.opportunityHistoryTxnOppId
});

const mapDispatchToProps = {
    fetchOpportunityHistory,
    setEventSummaryRowData,
    fetchOpportunityHistoryTableDetails,
    fetchOpportunityHistoryLogDetails,
    setIsOpportunityHistoryDetailsModalOpen,
    setIsOpportunityHistoryDetailsModalLoading,
    closeViewOpportunityHistoryDetails,
    closeViewOpportunityDetails,
    appNotify
};

export default compose(
    withStyles(styles),
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(ViewOpportunityHistoryModal);